function accessibilityCheck () {
    /* don't read header based on screen type */
    var screen_width = window.outerWidth;
    // Check if Desktop
    if (screen_width > 1025) { 
        var mobile_nav = document.getElementsByClassName('mobile-nav');
        for (var i=0;i<mobile_nav.length;i++) {
            var nav = mobile_nav[i];
            nav.setAttribute('aria-hidden', 'true');
            nav.classList.add('hidden');
        }
        // mobile_nav.setAttribute('aria-hidden', 'true');
        var nav_drawer = document.getElementById('NavDrawer');
        nav_drawer.setAttribute('aria-hidden', 'true');
    } else {
        var desktop_id = document.getElementById('desktop-header');
        desktop_id.setAttribute('aria-hidden', 'true');
        desktop_id.setAttribute('inert', ''); // fix tabindex elements
    }

    var trapFocusInModal = function(el) {
        var query = "a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type='email']:not([disabled]), input[type='text']:not([disabled]), input[type='radio']:not([disabled]), input[type='checkbox']:not([disabled]), select:not([disabled]), [tabindex='0']"
        var focusableEls = el.querySelectorAll(query);
        var firstFocusableEl = focusableEls[0];
        var lastFocusableEl = focusableEls[focusableEls.length - 1];
        if (lastFocusableEl.ariaHidden) {
            lastFocusableEl = focusableEls[focusableEls.length - 2];
        }
        el.addEventListener('keydown', function(e) {
            var isTabPressed = (e.key === "Tab" || e.keyCode === tab);
            var isEscPressed = (e.key === "Escape" || e.keyCode === esc);
            // Define behaviour for Tab or Shift+Tab
            if (isTabPressed) {
                // Shift+Tab
                if (e.shiftKey) {
                    if (document.activeElement === firstFocusableEl) {
                        lastFocusableEl.focus({focusVisible : true});
                        e.preventDefault();
                    }
                }
                // Tab
                else {
                    if (document.activeElement === lastFocusableEl) {
                        firstFocusableEl.focus({focusVisible : true});
                        e.preventDefault();
                    }
                }
            }
            // Define behaviour for Escape
            if (isEscPressed) {
                if (document.body.contains(el) && el.querySelector("a.popup--close-btn") != undefined) {
                    el.querySelector("a.popup--close-btn").click();
                    el.removeAttribute('open');
                    el.classList.remove('visible');
                    el.classList.add('hidden');
                    el.setAttribute('aria-hidden', 'true');
                    el.setAttribute('aria-expanded', 'false');

                    var sharing = document.getElementById('sharing');
                    sharing.focus({focusVisible : true});
                } else if (document.body.contains(el) && el.querySelector('button.icon-fallback-text') != undefined) {
                    el.setAttribute('aria-hidden', 'true');
                    el.setAttribute('aria-expanded', 'false');
                    el.querySelector('button.icon-fallback-text').click();
                }

            }
        });
    };
    var tab = 9;
    var enter = 13;
    var esc = 27;
    var count = 0;

    // check visibility of popup
    var focus_popup = function() {
        var popup = document.getElementById('popup');
        var slide_up = document.getElementById('slide-up');
        var isHidden = (slide_up.getAttribute('style') === 'display:none;') ? true : false;
        if (!isHidden && document.body.contains(popup)) {
            popup.setAttribute('open', '');
            // var close_btn = document.getElementsByClassName('popup--close-btn')[0];
            // var share_icons = popup.getElementsByClassName('popup--body')[0];
            // var close_dialog = function(e) {
            //     if (e.keyCode == esc || e.key == 'Esc') {
            //         popup.removeAttribute('open');
            //         popup.classList.remove('visible');
            //         popup.classList.add('hidden');
            //         popup.setAttribute('aria-hidden', 'true');
            //         popup.setAttribute('aria-expanded', 'false');
            //         // trigger.focus({focusVisible : true});
            //         var sharing = document.getElementById('sharing');
            //         sharing.focus({focusVisible : true});
            //         popup.removeEventListener('keydown', close_dialog, true);
            //     }
            // };
            
            popup.focus({focusVisible : true});
            trapFocusInModal(popup);
            // popup.click();
            // popup.addEventListener('keydown', close_dialog, true);
            setTimeout(()=> {
                // hack for accessibility app as it is not reading div
                var focus = document.activeElement;
                if (focus == popup) {
                    var announce_window = document.getElementById('accessibility_element');
                    announce_window.click();
                }
            }, 750);
        } else {
            setTimeout(() => {
                if (count <= 3) {
                    focus_popup();
                    count++;
                }
            }, 1000);
        }
    };
    
    /* Account Settings Check */
    var account_slider = function() {
        var loginBtn = document.querySelector('a.log-in-button');
        if (loginBtn != undefined) {
            var handle_keycode = function(e) {
                e.preventDefault();
                var drawer_container = document.getElementById('drawer_container');
                var is_visible = document.body.contains(drawer_container);
                if (drawer_container != undefined) {
                    drawer_container.focus({focusVisible: true});
                }
                // var close_slide_in = function(e) {
                //     if (e.keyCode == enter || e.keyCode == esc) {
                //         accountCloseBtn.click();
                //         loginBtn.focus({focusVisible : true});
                //     }
                // };
                // var accountCloseBtn = document.querySelector('.drawer.drawer--right.drawer--cart button.icon-fallback-text');
                if (e.keyCode == enter || e.key === "Enter") {
                    if (is_visible) {
                        var accountCloseBtn = document.getElementById('drawer_slider_close');
                        if (accountCloseBtn != document.activeElement) {
                            // var slider_name = document.querySelector('.drawer__header.sitewide--title-wrapper span');
                            var slider_name = document.getElementById('CustomerEmail');
                            slider_name.focus({focusVisible: true});
                            var focus = document.activeElement;
                            focus.click(); // force reader to acknowledge focus
                        }
                        drawer_container.setAttribute('aria-hidden', 'false');
                        // accountCloseBtn.addEventListener('keydown', close_slide_in, true);
                        trapFocusInModal(drawer_container);
                    }
                } else if (e.keyCode == esc) {
                    // drawer_container.setAttribute('aria-hidden', 'true');
                    // drawer_container.setAttribute('aria-expanded', 'false');
                    loginBtn.focus({focusVisible : true});
                    // accountCloseBtn.removeEventListener('keydown', close_slide_in, true);
                }
            };
            loginBtn.addEventListener('keydown', function(e) {
                // Give it some time to slide in
                if (e.keyCode == enter || e.keyCode == esc) {
                    setTimeout(()=> {
                        handle_keycode(e);
                    }, 500);
                }
            });
        }
    };

    setTimeout(() => {
        focus_popup();
        account_slider();
    }, 6000);
}

function footer_accessibility_button() {
    var accessibilty_widget = document.querySelector('button.accessibly-otm-widget-button');
    accessibilty_widget.click();
}

function submenu_accessibility_nav() {
    if (!Element.prototype.closest) {
        Element.prototype.closest = function(s) {
            var el = this;
            if (!document.documentElement.contains(el)) return null;
            do {
                if (el.matches(s)) return el;
                el = el.parentElement || el.parentNode;
            } while (el !== null && el.nodeType === 1);
            return null;
        };
    }
    
    /*
    / walk through all links
    / watch out whether they have an 'aria-haspopup'
    / as soon as a link has got the 'focus' (also key), then:
    / set nested UL to 'display:block;'
    / set attribute 'aria-hidden' of this UL to 'false'
    / and set attribute 'aria-expanded' to 'true'
    */
    
    var opened;
    
    // resets currently opened list style to CSS based value
    // sets 'aria-hidden' to 'true'
    // sets 'aria-expanded' to 'false'
    var reset = function() {
        if (opened) {
            opened.style.display = '';
            opened.setAttribute('aria-hidden', 'true');
            opened.setAttribute('aria-expanded', 'false');
        }
    }
    
    // sets given list style to inline 'display: block;'
    // sets 'aria-hidden' to 'false'
    // sets 'aria-expanded' to 'true'
    // stores the opened list for later use
    var open = function(el) {
        el.style.display = 'block';
        el.setAttribute('aria-hidden', 'false');
        el.setAttribute('aria-expanded', 'true');
        opened = el;
        el.focus({focusVisible : true});
    }
    
    // event delegation
    // reset navigation on click outside of list
    document.addEventListener('click', function(event) {
        if (!event.target.closest('[aria-hidden]')) {
            reset();
        }
    });
    
    // event delegation
    document.addEventListener('focusin', function(event) {
        // reset list style on every focusin
        reset();
    
        // check if a[aria-haspopup="true"] got focus
        var target = event.target;
        var hasPopup = target.getAttribute('aria-haspopup') === 'true';
        if (hasPopup) {
            open(event.target.nextElementSibling);
            return;
        }
    
        // check if anchor inside sub menu got focus
        var popupAnchor = target.parentNode.parentNode.previousElementSibling;
        var isSubMenuAnchor = popupAnchor && popupAnchor.getAttribute('aria-haspopup') === 'true';
        if (isSubMenuAnchor) {
            open(popupAnchor.nextElementSibling);
            return;
        }
    });

    var tab = 9;
    var enter = 13;
    var esc = 27;
    var arrowDown = 40;

    var reset_menu = function(el) {
        if (el != undefined) {
            el.style.visibility = '';
            el.style.display = '';
            // el.setAttribute('aria-hidden', 'true');
            // el.setAttribute('aria-expanded', 'false');
        }
    };

    document.querySelectorAll('.site-nav--has-dropdown').forEach((element)=> {
        var query = "a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type='email']:not([disabled]), input[type='text']:not([disabled]), input[type='radio']:not([disabled]), input[type='checkbox']:not([disabled]), select:not([disabled]), [tabindex='0']"
        var focusableEls = element.querySelectorAll(query);
        var firstFocusableEl = focusableEls[0];
        var lastFocusableEl = focusableEls[focusableEls.length - 1];
        element.addEventListener('keydown', function(e){
            if (e.keyCode == tab) {
                var currentTarget = e.currentTarget;
                var child_element = currentTarget.querySelector('a.site-nav__link'); 
                if (child_element != document.activeElement) {
                    return;
                }
            }
            if (e.keyCode == enter || e.keyCode == arrowDown || e.key === "Enter" || e.key === "Enter") {
                e.preventDefault();
                var currentElement = e.currentTarget;
                var child_element = currentElement.querySelector('a.site-nav__link'); 
                if (child_element != document.activeElement) {
                    return;
                }
                if (currentElement.classList.contains('site-nav--has-dropdown')) {
                    // currentElement.style.visibility = 'visible';
                    // currentElement.style.opacity = '1';
                    currentElement.classList.add('nav-hover');
                    currentElement.querySelector('.site-nav__link').classList.add('nav-focus');
                    // var first_item = currentElement.querySelector('p.h4 a');
                    var first_item = currentElement.querySelector('.dropdown-submenu');
                    if (first_item != null) {
                        first_item.focus({focusVisible : true});
                    }
                    var dropdown = currentElement.querySelector('.site-nav__dropdown');
                    dropdown.style.visibility = 'visible';
                    dropdown.style.display = 'block';
                    // dropdown.setAttribute('aria-hidden', 'false');
                    // dropdown.setAttribute('aria-expanded', 'true');

                    var menu_link = currentElement.querySelectorAll('.menu-link');
                    if (menu_link.length > 0) {
                        menu_link.forEach(function(element) {
                            element.setAttribute('aria-hidden', 'false');
                            element.setAttribute('aria-expanded', 'true');
                        });
                    }
                }
            } else if (e.keyCode == esc) {
                var nav_hover = document.querySelector('.site-nav--has-dropdown.nav-hover');
                if (nav_hover != undefined) {
                    reset_menu(nav_hover);
                    nav_hover.classList.remove('nav-hover');
                    var dropdown = document.getElementsByClassName('site-nav__dropdown');
                    for (var j=0;j<dropdown.length;j++) {
                        reset_menu(dropdown[j]);
                    }
                    e.currentTarget.focus({focusVisible : true});
                    if (e.currentTarget != document.activeElement){
                        document.getElementById('AccessibleNav').focus({focusVisible : true});
                    }
                }
            }
        });
    });
}

function removeTargetBlank() {
    const links = document.querySelectorAll('a[target="_blank"]');
    const currentHostname = window.location.hostname === '127.0.0.1' ? 'latourangelle.com' : window.location.hostname;

    links.forEach(link => {
        const linkHostname = new URL(link.href).hostname;
        if (linkHostname === currentHostname) {
            link.removeAttribute('target');
        } else {
            // not safe just yet
            // link.removeAttribute('target');
        }
    });
}

removeTargetBlank();
accessibilityCheck();
setTimeout(()=> {
    submenu_accessibility_nav();
}, 500);